import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import PromotionsList from './components/PromotionsList';
import ActionBar from '../layout/ActionBar';
import { NavLink } from 'react-router-dom';
import { getKeyProviders } from '../../actions/keyProviderActions';
import { getAllTerritories } from '../../actions/territoryActions';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function Promotions() {
  const dispatch = useAppDispatch();
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const territories = useAppSelector((state) => state.territories);
  const { t } = useTranslation();
  usePageTitle(['All promotions']);
  const [reload, setReload] = useState(undefined);

  useEffect(() => {
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
  }, [keyProviders, dispatch]);

  useEffect(() => {
    if (!territories) {
      dispatch(getAllTerritories());
    }
  }, [territories, dispatch]);

  return (
    <>
      <ActionBar
        breadcrumb={[
          {
            link: '/promotions',
            label: t('All promotions'),
          },
        ]}
      >
        <NavLink className="btn btn-primary" to="/promotion/add">
          {t('Add promotion')}
        </NavLink>
      </ActionBar>
      <PromotionsList
        reload={reload}
        keyProviders={keyProviders}
        territories={territories}
      />
    </>
  );
}

export default Promotions;
